module.exports = __webpack_public_path__ + "img/find_hi.7b14202a.jpg";